
import {
    useListLandscapeQuidTopics
} from './useListeningQueryPersistence.js';

import {
    listeningDefinitions
} from '../components/enums/listeningDefinitions.jsx';


export default function useValidateQuidMonitorTopic(selectedTopicId, selectedThemeIds) {
    const {data: allQuidMonitorTopics, isLoading} = useListLandscapeQuidTopics();

    const {
        duplicateComboError
    } = listeningDefinitions['quid-monitor-topic-configure-modal'];

    const conflictsWithOther = _.find(allQuidMonitorTopics, quidMonitorTopic => {
        return (
            _.isEqual(quidMonitorTopic.definition.topicId, selectedTopicId) &&
            _.isEqual(_.sortBy(quidMonitorTopic.definition.themeIds), _.sortBy(selectedThemeIds))
        );
    });

    if (!isLoading && conflictsWithOther) {
        return {
            error: {
                message: duplicateComboError
            }
        };
    }

    return {
        error: null
    };
}
